import { render } from "./PrimarySearch.vue?vue&type=template&id=fb09c4c2&scoped=true"
import script from "./PrimarySearch.vue?vue&type=script&lang=js"
export * from "./PrimarySearch.vue?vue&type=script&lang=js"

import "./PrimarySearch.vue?vue&type=style&index=0&id=fb09c4c2&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fb09c4c2"]])

export default __exports__